import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, hasPermission } from '@/lib/auth';

/**
 * Wraps the whole /driver tree. orders.assigned.edit is the permission the
 * driver role (and legacy rider) holds -- gating on that rather than a role
 * string means a permission change server-side needs no frontend deploy,
 * same reasoning as AdminGuard.
 *
 *   - No session → /login with a return URL
 *   - Authed but doesn't hold it → /account (a customer or admin has no
 *     business here; this is a working tool for someone with a route today)
 *   - Holds it → render children
 */
export function DriverGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const isAuthed = useAuthStore((s) => s.isAuthenticated());
  const loc = useLocation();

  if (!isAuthed || !user) {
    return <Navigate to={`/login?return=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  if (!hasPermission(user, 'orders.assigned.edit')) {
    return <Navigate to="/account" replace />;
  }
  return <>{children}</>;
}
